module.exports = __webpack_public_path__ + "static/Awasul_banner_image-5e95ac57e841fdf82338f6c866a3fe02.png";